import React, { forwardRef, useImperativeHandle, useState } from 'react';
import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from '@mui/material';
import PropTypes from 'prop-types';

const DeviceManagerForm = forwardRef(function (
  { onSubmit, residents, rooms },
  ref,
) {
  const [formData, setFormData] = useState({
    residentId: '',
    deviceId: '',
    roomId: '',
  });

  useImperativeHandle(ref, () => ({
    resetForm: () => {
      setFormData({
        residentId: '',
        deviceId: '',
        roomId: '',
      });
    },
    setForm: (data) => {
      setFormData(data);
    },
  }));

  const handleChange = (prop) => (event) => {
    setFormData({ ...formData, [prop]: event.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box>
        <TextField
          label="Device ID"
          type="text"
          value={formData.deviceId}
          onChange={handleChange('deviceId')}
          inputProps={{ minLength: 3 }}
          margin="normal"
          fullWidth
          required
        />
      </Box>
      <Box>
        <FormControl fullWidth margin="normal" required>
          <InputLabel id="ARLabel">Resident</InputLabel>
          <Select
            value={formData.residentId}
            onChange={handleChange('residentId')}
            labelId="ARLabel"
            label="Residents"
            required
          >
            {residents.map((resident) => (
              <MenuItem key={resident.id} value={resident.id}>
                {resident.residentName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth margin="normal">
          <InputLabel id="ARLabel">Room</InputLabel>
          <Select
            value={formData.roomId}
            onChange={handleChange('roomId')}
            labelId="ARLabel"
            label="Rooms"
          >
            {rooms.map((room) => (
              <MenuItem key={room.id} value={room.id}>
                {room.roomName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Button type="submit" variant="contained" color="primary">
        Add
      </Button>
      <Button
        style={{ marginLeft: 10 }}
        variant="contained"
        color="error"
        onClick={() => {
          setFormData({
            residentId: '',
            deviceId: '',
          });
        }}
      >
        Clear
      </Button>
    </form>
  );
});

DeviceManagerForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  residents: PropTypes.arrayOf(
    PropTypes.shape({ residentName: PropTypes.string, id: PropTypes.string }),
  ),
  rooms: PropTypes.arrayOf(
    PropTypes.shape({ roomName: PropTypes.string, id: PropTypes.string }),
  ),
};

DeviceManagerForm.displayName = 'DeviceManagerForm';
export default DeviceManagerForm;
